<template>
    <div class="flex items-center pb-1 pt-px">
        <label v-if="title" class="flex-none uppercase leading-none text-xs text-gray-warm-600 font-semibold tracking-relaxed my-0 pr-3">
            {{ $t(title) }}
        </label>

        <div class="h-2 relative flex-1 bg-gray-warm-300 my-0 w-16 sm:w-24 xl:w-48 mb-px">
            <div class="absolute top-0 left-0 h-full"
                :class="color == 'blue' ? 'bg-blue-400' : 'bg-green-400'"
                :style="{ width: display_value + '%' }"
            ></div>
        </div>

        <p class="leading-none text-xs text-gray-warm-600 font-semibold tracking-relaxed my-0 pl-3">{{ display_value }}%</p>
    </div>
</template>

<script>
export default {
    props: {
        title: {},
        section: {},
        value: {},
        color: { default: 'green' },
    },

    computed: {
        store_value() {
            return this.section == 'overall'
                ? store.state.property_progress_overall
                : store.state.property_progress_sections?.[this.section];
        },
        display_value() {
            return this.store_value || this.value;
        }
    },
}
</script>
